import { render, staticRenderFns } from "./DatosDespacho.vue?vue&type=template&id=5ead1b79&scoped=true"
import script from "./DatosDespacho.vue?vue&type=script&lang=js"
export * from "./DatosDespacho.vue?vue&type=script&lang=js"
import style0 from "./DatosDespacho.vue?vue&type=style&index=0&id=5ead1b79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ead1b79",
  null
  
)

export default component.exports